import { render, staticRenderFns } from "./App2018.vue?vue&type=template&id=7b560860&scoped=true&"
import script from "./App2018.vue?vue&type=script&lang=js&"
export * from "./App2018.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b560860",
  null
  
)

export default component.exports